import Vue from 'vue'
import Router from 'vue-router'
import Login from './Login.vue'
import Home from './Home.vue'
import Adatok from './components/DiakAdatok.vue'
import License from './components/DiakLicense.vue'
import Courses from './components/DiakTanfolyam.vue'
import Contracts from './components/Contracts.vue'
import Payments from './components/DiakPayments.vue'
import Exams from './components/DiakVizsga.vue'
import Gyakorlat from './components/DiakGyakorlat.vue'
import firebase from 'firebase/app'
import 'firebase/auth';

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/adatok',
      name: 'adatok',
      component: Adatok
    },
    {
      path: '/jogsi',
      name: 'jogsi',
      component: License
    },
    {
      path: '/kategoriak',
      name: 'kategoriak',
      component: Contracts
    },
    {
      path: '/tanfolyamok',
      name: 'tanfolyamok',
      component: Courses
    },
    {
      path: '/penzugy',
      name: 'penzugy',
      component: Payments
    },
    {
      path: '/vizsgak',
      name: 'vizsgak',
      component: Exams
    },
    {
      path: '/gyakorlat',
      name: 'gyakorlat',
      component: Gyakorlat
    },
  ]
})


router.beforeEach((to, from, next) => {
  firebase.auth().onAuthStateChanged(user => {
    if (!user && to.path !== '/login') {
      next('login')
    } else if (user && user.isAnonymous && to.path !== '/login') {
      next('login')
    } else {
      next()
    }
  })
})

export default router
